import { useCallback } from 'react';
import { ApiError } from './client';

export type ErrorInput = ApiError | Error | { message?: string } | string | null | undefined;

export const getErrorMessage = (err: unknown): string => {
  if (!err) return 'Unknown error';
  if (err instanceof ApiError) {
    if (err.errorId) {
      return `${err.message} (Error ID: ${err.errorId})`;
    }
    return err.message;
  }
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  if (typeof err === 'number' || typeof err === 'boolean') return String(err);
  if (typeof err === 'object' && 'message' in err) {
    const message = (err as { message?: unknown }).message;
    if (typeof message === 'string') return message;
  }
  try {
    return JSON.stringify(err);
  } catch {
    return 'Unknown error';
  }
};

export const useApiErrorMessage = (): ((err: unknown) => string) =>
  useCallback((err: unknown): string => getErrorMessage(err), []);
